import { Component, OnInit } from '@angular/core';
import { UIDialogComponent } from '@bannerflow/ui';
import { SafeUrl, DomSanitizer } from '@angular/platform-browser';

@Component({
    selector: 'font-manager',
    templateUrl: 'font-manager.component.html',
    styleUrls: ['font-manager.component.scss']
})
export class FontManagerComponent implements OnInit {
    url: SafeUrl;
    constructor(
        private dialogComponent: UIDialogComponent,
        private sanitizer: DomSanitizer
    ) {}

    ngOnInit(): void {
        this.url = this.sanitizer.bypassSecurityTrustResourceUrl(
            this.dialogComponent.config.data.fontManagerUri
        );
    }
}
